export default __webpack_public_path__ + "5cc1a35357bd4e90a07bff951deb6ca4.webp";